import React from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import SmallSpinner from 'app/components/spinner/smallSpinner';
import vouchersViewStore from 'modules/ticketPublicPage/stores/vouchers/view';
import Info from './common/Info';
import BuyVoucher from './BuyVoucher';
import PrivacyLinks from './PrivacyLinks';
import {
  Container,
  FlexWrapper,
  FullScreenDetails,
  FullScreenFlex
} from './styles/_main';

const Main = observer(() => {
  return vouchersViewStore.activeObject ? (
    <Container>
      <FullScreenDetails>
        <Info />
      </FullScreenDetails>
      <FullScreenFlex>
        <FlexWrapper>
          <BuyVoucher />
        </FlexWrapper>
        <PrivacyLinks />
      </FullScreenFlex>
    </Container>
  ) : (
    <SmallSpinner />
  );
});

export default withRouter(Main);
